export default {
  path: '/customer-analysis',
  component: { render: h => h('router-view') },
  children: [
    {
      path: '/customer-analysis/customer-management/home',
      component: () =>
        import(/* webpackChunkName: "customer-home" */ './home/home'),
    },
    {
      path: '/customer-analysis/customer-management/create-customer',
      name: 'createCustomer',
      component: () =>
        import(
          /* webpackChunkName: "customer-home" */ './create-customer/create-customer'
        ),
    },
    {
      path: '/customer-analysis/customer-management/create-css-customer',
      name: 'createCssCustomer',
      component: () =>
        import(
          /* webpackChunkName: "customer-home" */ './create-customer/create-css-customer'
        ),
    },
    {
      path: '/customer-analysis/customer-management/credit-line-detail',
      name: 'creditLineDetail',
      component: () =>
        import(
          /* webpackChunkName: "customer-home" */ './create-customer/credit-line-detail'
        ),
    },
    // 客户信息详情路由 =》》》 开始
    {
      path: '/customer-analysis/customer-management/:customerId',
      component: () => import('./detail/detail'),
      children: [
        {
          path: '/customer-management/:customerId/info',
          component: {
            render: h => h('router-view'),
          },
          redirect: '/customer-management/:customerId/info/snapshot',
          children: [
            {
              path: '/customer-management/:customerId/info/snapshot',
              component: () => import('./detail/info/snapshot/snapshot'),
            },
            {
              path: '/customer-management/:customerId/info/basic-profile',
              component: () =>
                import('./detail/info/basic-profile/basic-profile'),
            },
            {
              path: '/customer-management/:customerId/info/ar-data',
              component: () => import('./detail/info/ar-data/ar-data'),
            },
            {
              path: '/customer-management/:customerId/info/credit-trend',
              component: () =>
                import('./detail/info/credit-trend/credit-trend'),
            },
            {
              path: '/customer-management/:customerId/info/credit-line',
              component: () => import('./detail/info/credit-line/credit-line'),
            },
            {
              path: '/customer-management/:customerId/info/collateral',
              component: () => import('./detail/info/collateral/index.vue'),
            },
            {
              path: '/customer-management/:customerId/info/collateral-detail',
              component: () =>
                import('./detail/info/collateral/collateral-detail.vue'),
            },
            {
              path: '/customer-management/:customerId/info/collateralAdd-detail',
              component: () =>
                import('./detail/info/collateral/collateralAdd-detail.vue'),
            },
            {
              path: '/customer-management/:customerId/info/insurance',
              component: () => import('./detail/info/insurance/'),
            },
            {
              path: '/customer-management/:customerId/info/insurance-detail',
              component: () =>
                import('./detail/info/insurance/insurance-detail.vue'),
            },
            {
              path: '/customer-management/:customerId/info/insuranceAdd-detail',
              component: () =>
                import('./detail/info/insurance/insuranceAdd-detail.vue'),
            },
            {
              path: '/customer-management/:customerId/info/notes',
              component: () => import('./detail/info/notes/notes.vue'),
            },
            {
              path: '/customer-management/:customerId/info/addNotes',
              component: () => import('./detail/info/notes/addNotes.vue'),
            },
            {
              path: '/customer-management/:customerId/:id/info/editNotes',
              component: () => import('./detail/info/notes/editNotes.vue'),
            },
          ],
        },
        {
          path: '/customer-management/:customerId/financial-report',
          component: () => import('./detail/financial-report/financial-report'),
        },
        {
          path: '/customer-management/:customerId/financial-analysis',
          component: () =>
            import('./detail/financial-analysis/financial-analysis'),
        },
        {
          path: '/customer-management/:customerId/credit-method',
          component: () => import('./detail/credit-method/credit-method'),
        },
        {
          path: '/customer-management/:customerId/business-hierarchy',
          component: () =>
            import('./detail/business-hierarchy/business-hierarchy'),
        },
        {
          path: '/customer-management/:customerId/scores',
          component: () => import('./detail/scores/scores'),
        },
        {
          path: '/customer-management/scores/:customerId/score-model/:cardId',
          name: 'score-model',
          component: () => import('./detail/scores/score-model'),
        },
        {
          path: '/customer-management/scores/:customerId/score-result/:id',
          name: 'score-result',
          component: () => import('./detail/scores/score-result'),
        },
        {
          path: '/customer-management/scores/:customerId/score-other/:id',
          name: 'score-other',
          component: () => import('./detail/scores/score-other'),
        },
        {
          path: '/customer-management/:customerId/add-scores',
          name: 'addScores',
          component: () => import('./detail/scores/add-scores'),
        },
        {
          path: '/customer-management/:customerId/bureau-report',
          name: 'bureau-report',
          component: () => import('./detail/bureau-report/bureau-report'),
        },
        {
          path: '/customer-management/:customerId/bureau-report/add',
          name: 'bureau-report-add',
          component: () => import('./detail/bureau-report/add/add'),
        },
        {
          path: '/customer-management/:customerId/bureau-report/detail',
          name: 'bureau-report-detail',
          component: () => import('./detail/bureau-report/detail/detail'),
        },
        {
          path: '/customer-management/:customerId/bureau-report/mock-detail',
          name: 'bureau-report-mock-detail',
          component: () => import('./detail/bureau-report/detail/mock-detail'),
        },
        {
          path: '/customer-management/:customerId/tnc-details',
          component: () => import('./detail/tnc-details/tnc-details'),
        },
        {
          path: '/customer-management/:customerId/tnc-detail/:id',
          name: 'tnc-detail',
          component: () => import('./detail/tnc-details/detail'),
        },
        {
          path: '/customer-management/:customerId/css-finacial-reports',
          component: () =>
            import('./detail/css-finacial-reports/css-finacial-reports'),
        },
        {
          path: '/customer-management/:customerId/css-finacial-analysis',
          component: () =>
            import('./detail/css-finacial-analysis/css-finacial-analysis'),
        },
      ],
    },
    // 客户信息详情路由 =》》》 结束
    {
      path: '/customer-analysis/black-list',
      component: () =>
        import(/* webpackChunkName: "black-list" */ './black-list/black-list'),
    },
    {
      path: '/customer-analysis/batch-import',
      component: () => import('./batch-import/batch-import'),
    },
  ],
}
